
export enum PromotionEventType {
    EVENTO = "EVENTO", 
    PROMOZIONE = "PROMOZIONE"
}

export enum PromotionEventUrlClickAndCollectType{
    FISSA_APPUNTAMENTO = "FISSA_APPUNTAMENTO", 
    SIM = "SIM",
    SMARTPHONE  = "SMARTPHONE "
}


export class PromotionEventRequest{
    analyticsCode: string = "";
    index : number = 0;
    description: string = "";
    description2: string = "";
    expirationTime: string = "";
    landingPagePromotion: string = "";
    name: string = "";
    promotionAppointment: boolean = false;
    promotionVisibility: boolean = false;
    seoDescription: string = "";
    seoId: string = "";
    seoTitle: string = "";
    startTime: string = "";
    startDay: string = "";
    expirationDay: string = "";
    type: PromotionEventType;
    urlBookAndCollect: string;
    urlClickAndCollectType: PromotionEventUrlClickAndCollectType;
    documentId:number;
    iconId: number;
    constructor(){
        this.analyticsCode = "";
        this.index = 0;
        this.description = "";
        this.description2 = "";
        this.expirationTime = "";
        this.landingPagePromotion = "";
        this.name = "";
        this.promotionAppointment = false;
        this.promotionVisibility = false;
        this.seoDescription = "";
        this.seoId = "";
        this.seoTitle = "";
        this.startTime = "";
        this.startDay = "";
        this.expirationDay = "";
    }
}

export class PromotionEventRequestList{
    pageSize: number;
    pageNumber: number;
    
}

export class PromotionEventRequestSearch{
    name: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    
}

